import { getTranslatedString } from '@/utils';

import { CampaignYearNameSync } from './campaign-year-name-sync';

const monthOptions = () =>
  Array.from({ length: 12 }, (_, i) => ({
    value: i + 1,
    label: getTranslatedString(`common.month.${i + 1}`),
  }));

const dayOptions = () =>
  Array.from({ length: 31 }, (_, i) => ({
    value: i + 1,
    label: String(i + 1),
  }));

/** Must match permission_objects slug `campaign.name` (not i18n key `campaigns.name`). */
const layoutPermissionName = 'campaign.name';

export const getFormFields = () => {
  return [
    {
      id: 'campaign-section-identity',
      name: '_sectionIdentity',
      componentName: 'form-divider',
      permissionName: layoutPermissionName,
      params: {
        i18nLabel: 'campaigns.sectionIdentity',
        i18nHelpTitle: 'campaigns.formIntroTitle',
        i18nHelpDescription: 'campaigns.formIntroDescription',
        i18nHelpAriaLabel: 'campaigns.formIntroHelpAriaLabel',
      },
    },
    {
      name: 'name',
      componentName: 'input',
      params: {
        i18nLabel: 'campaigns.name',
        i18nExtra: 'campaigns.nameExtra',
      },
      rules: [
        { required: true },
        { max: 255 },
        {
          pattern: /^\[\d{4}(?:\s*-\s*\d{4})?\]\s+.+/,
          message: getTranslatedString('campaigns.namePatternError'),
        },
      ],
    },
    {
      id: 'campaign-year-name-sync',
      name: '_yearNameSync',
      component: CampaignYearNameSync,
      componentName: 'input',
      permissionName: layoutPermissionName,
      params: {},
      rules: [],
    },
    {
      name: 'year',
      componentName: 'input',
      params: {
        i18nLabel: 'campaigns.year',
        i18nExtra: 'campaigns.yearExtra',
        disabled: true,
      },
      rules: [{ required: true }, { max: 4 }],
    },
    {
      id: 'campaign-section-main',
      name: '_sectionMainCrop',
      componentName: 'form-divider',
      permissionName: layoutPermissionName,
      params: {
        i18nLabel: 'campaigns.sectionMainCrop',
      },
    },
    {
      name: 'mainStartMonth',
      componentName: 'dropdown',
      params: {
        i18nLabel: 'campaigns.mainStartMonth',
        i18nExtra: 'campaigns.mainWindowExtra',
        options: monthOptions(),
      },
      rules: [{ required: true }],
    },
    {
      name: 'mainStartDay',
      componentName: 'dropdown',
      params: {
        i18nLabel: 'campaigns.mainStartDay',
        options: dayOptions(),
      },
      rules: [{ required: true }],
    },
    {
      name: 'mainEndMonth',
      componentName: 'dropdown',
      params: {
        i18nLabel: 'campaigns.mainEndMonth',
        options: monthOptions(),
      },
      rules: [{ required: true }],
    },
    {
      name: 'mainEndDay',
      componentName: 'dropdown',
      params: {
        i18nLabel: 'campaigns.mainEndDay',
        options: dayOptions(),
      },
      rules: [{ required: true }],
    },
    {
      id: 'campaign-section-mid',
      name: '_sectionMidCrop',
      componentName: 'form-divider',
      permissionName: layoutPermissionName,
      params: {
        i18nLabel: 'campaigns.sectionMidCrop',
      },
    },
    {
      name: 'midStartMonth',
      componentName: 'dropdown',
      params: {
        i18nLabel: 'campaigns.midStartMonth',
        i18nExtra: 'campaigns.midWindowExtra',
        options: monthOptions(),
      },
      rules: [{ required: true }],
    },
    {
      name: 'midStartDay',
      componentName: 'dropdown',
      params: {
        i18nLabel: 'campaigns.midStartDay',
        options: dayOptions(),
      },
      rules: [{ required: true }],
    },
    {
      name: 'midEndMonth',
      componentName: 'dropdown',
      params: {
        i18nLabel: 'campaigns.midEndMonth',
        options: monthOptions(),
      },
      rules: [{ required: true }],
    },
    {
      name: 'midEndDay',
      componentName: 'dropdown',
      params: {
        i18nLabel: 'campaigns.midEndDay',
        options: dayOptions(),
      },
      rules: [{ required: true }],
    },
  ];
};
